import { EnquiresActionTypes, EnquiryState } from 'types';
import { Reducer } from 'redux';
import Utils from 'utilities/helper.util';

const initialState: EnquiryState = {
  loading: false,
  enquiryLoader: false,
  error: '',
  data: {
    enquiries: undefined,
    lodgeEnquiry: undefined,
    filters: undefined,
    enquiry: undefined,
    forwardDateRangeText: ''
  },
  downloadAdvancedOptions: [],
  isLoadingDownloadAdvancedOptions: false
};

const reducer: Reducer<EnquiryState> = (state = initialState, action: any) => {
  switch (action.type) {
    case EnquiresActionTypes.FETCH_ENQUIRY_BYID: {
      const { data } = state;
      const enquiry = data?.enquiry;
      state = {
        enquiryLoader: true,
        data: {
          ...data,
          enquiry
        }
      };

      return state;
    }
    case EnquiresActionTypes.FETCH_ENQUIRY_BYID_SUCCESS: {
      const { Referrals, externalId, isSandboxTest } = action?.payload;
      const referrals = Referrals.map((item: any) => {
        const {
          status,
          externalId,
          Organisation,
          Responses,
          ReferralConfiguration
        } = item;
        const {
          contactEmergencyPhone,
          contactPhoneNumber,
          contactEmail,
          name,
          organisationType,
          TypicalWaitTime,
          Notices,
          id,
          contactUrl,
          safetyMessage,
          LogoImageFile
        } = Organisation;

        const responses = Responses.map((res: any) => {
          const {
            id,
            InboundEmail,
            inboundEmailId,
            OutboundEmails,
            createdAt,
            created_at,
            custom_properties
          } = res;
          const outboundEmailId = OutboundEmails.map((email: any) => {
            const { id } = email;
            return id;
          });
          const inboundEmailIdFromObject = InboundEmail?.id || null;

          return {
            responseId: id,
            inboundEmailId: inboundEmailId || inboundEmailIdFromObject,
            outboundEmailId: outboundEmailId[0],
            createdAt: createdAt || created_at,
            custom_properties,
            primaryContent: ReferralConfiguration?.primaryContent
          };
        });

        const waittime = Number(TypicalWaitTime?.details.P90);
        return {
          contactEmergencyPhone,
          contactPhoneNumber,
          contactEmail,
          name,
          status,
          externalId,
          waittime,
          organisationType,
          isSandboxTest,
          responses,
          notices: Notices,
          organisationId: id,
          contactUrl,
          safetyMessage,
          logo: LogoImageFile?.id
        };
      });
      const { data } = state;
      state = {
        enquiryLoader: false,
        data: {
          ...data,
          enquiry: {
            ...action?.payload,
            jobId: externalId,
            referrals
          }
        }
      };
      return state;
    }
    case EnquiresActionTypes.FETCH_ENQUIRY_BYID_FAILURE: {
      return {
        ...state,
        enquiryLoader: false,
        error: action.payload
      };
    }
    case EnquiresActionTypes.UPDATE_ENQUIRY_BYID: {
      const { data } = state;
      const enquiry = data?.enquiry;
      state = {
        updatingEnquiry: true,
        data: {
          ...data,
          enquiry
        }
      };

      return state;
    }
    case EnquiresActionTypes.UPDATE_ENQUIRY_BYID_SUCCESS: {
      const { autoRenewUntil, isAutoRenewComplete } = action?.payload;
      const { data } = state;
      const enquiry = data?.enquiry;
      state = {
        updatingEnquiry: false,
        data: {
          ...data,
          enquiry: {
            ...enquiry,
            isAutoRenewComplete,
            autoRenewUntil
          }
        }
      };
      return state;
    }
    case EnquiresActionTypes.UPDATE_ENQUIRY_BYID_FAILURE: {
      return {
        ...state,
        updatingEnquiry: false,
        error: action.payload
      };
    }

    case EnquiresActionTypes.FETCH_ENQUIRY_HISTORY: {
      const { data } = state;
      const { enquiries } = data;
      state = {
        enquiryLoader: false,
        loading: enquiries ? false : true,
        loader: enquiries && true,
        data
      };
      return state;
    }
    case EnquiresActionTypes.FETCH_ENQUIRY_HISTORY_SUCCESS: {
      const { data } = state;
      const count = action?.payload?.count;
      const newEnquiryList = action?.payload?.items;

      // if (enquiryListState) {
      //   // const items =
      //   //   enquiryListState?.length >= count
      //   //     ? newEnquiryList
      //   //     : [...enquiryListState, ...newEnquiryList];
      //   const enquiries = {
      //     items: action?.payload?.items,
      //     count
      //   };
      //   state = {
      //     data: {
      //       enquiry,
      //       lodgeEnquiry,
      //       enquiries,
      //       filters
      //     }
      //   };
      // } else {
      const filteredEnquiries = {
        items: newEnquiryList,
        count
      };
      state = {
        data: {
          ...data,
          enquiries: filteredEnquiries
        }
      };
      // }
      return state;
    }
    case EnquiresActionTypes.FETCH_ENQUIRY_HISTORY_FAILURE: {
      state = {
        ...initialState,
        error: action.payload
      };
      return state;
    }

    case EnquiresActionTypes.FETCH_ENQUIRY_ACT_DESIGN: {
      const { data } = state;
      const excavationAct = data?.lodgeEnquiry?.excavationAct;
      // const enquiry = data?.lodgeEnquiry;
      state = {
        data: {
          ...data,
          // enquiry,
          lodgeEnquiry: {
            designAct: action.payload,
            excavationAct
          }
        }
      };

      return state;
    }
    case EnquiresActionTypes.FETCH_ENQUIRY_ACT_EXCAVATE: {
      const { data } = state;
      const designAct = data?.lodgeEnquiry?.designAct;
      return {
        data: {
          ...data,
          lodgeEnquiry: {
            designAct,
            excavationAct: action.payload
          }
        }
      };
    }
    case EnquiresActionTypes.SET_ENQUIRY_SEARCH_FILTER: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          filters: action.payload
        }
      };
      return state;
    }
    case EnquiresActionTypes.RESET_LODGE_ENQUIRY_STATE: {
      const { data } = state;
      state = {
        ...state,
        loading: false,
        data: {
          ...data,
          enquiry: {}
        }
      };
      return state;
    }

    case EnquiresActionTypes.RESET_ENQUIRY_SHAPE: {
      const { data } = state;
      const { enquiry } = data;
      const updatedData = !Utils.isObjectEmpty(enquiry)
        ? {
            shape: undefined,
            Address: undefined,
            shapeArea: undefined
          }
        : {};
      state = {
        ...state,
        loading: false,
        data: {
          ...data,
          enquiry: {
            ...enquiry,
            ...updatedData
          }
        }
      };
      return state;
    }

    case EnquiresActionTypes.SET_FORWARD_ENQUIRY_EXTERNAL_ID: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          forwardEnquiryExternalId: action.payload
        }
      };
      return state;
    }

    case EnquiresActionTypes.SET_FORWARD_ENQUIRY_IS_LIST_VIEW: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          forwardIsListView: action.payload
        }
      };
      return state;
    }

    case EnquiresActionTypes.SET_FORWARD_ENQUIRY_DATE_RANGE_TEXT: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          forwardDateRangeText: action.payload
        }
      };
      return state;
    }

    case EnquiresActionTypes.UPDATE_ENQUIRY_REFERRAL: {
      const { data } = state;
      const enquiry = data?.enquiry;

      if (enquiry?.referrals) {
        const oldReferralIndex = enquiry?.referrals.findIndex(
          (referral: any) => referral.externalId === action.payload.externalId
        );
        const {
          status,
          externalId,
          Organisation,
          Responses,
          isNewResponses,
          updatedAt
        } = action.payload;
        const {
          contactEmergencyPhone,
          contactPhoneNumber,
          contactEmail,
          name,
          organisationType,
          TypicalWaitTime,
          Notices,
          id
        } = Organisation;

        const responses = Responses.map((res: any) => {
          const {
            id,
            InboundEmail,
            inboundEmailId,
            OutboundEmails,
            createdAt,
            created_at,
            custom_properties
          } = res;
          const outboundEmailId = OutboundEmails.map((email: any) => {
            const { id } = email;
            return id;
          });

          const inboundEmailIdFromObject = InboundEmail?.id || null;

          return {
            responseId: id,
            inboundEmailId: inboundEmailId || inboundEmailIdFromObject,
            outboundEmailId: outboundEmailId[0],
            createdAt: createdAt || created_at,
            custom_properties
          };
        });

        const waittime = Number(TypicalWaitTime?.details.P90);
        const newReferral = {
          contactEmergencyPhone,
          contactPhoneNumber,
          contactEmail,
          name,
          status,
          externalId,
          waittime,
          organisationType,
          responses,
          notices: Notices,
          organisationId: id,
          isNewResponses,
          updatedAt
        };

        const oldReferral = enquiry.referrals[oldReferralIndex];
        const updatedReferrals = [...enquiry.referrals];
        updatedReferrals[oldReferralIndex] = {
          ...oldReferral,
          ...newReferral
        };
        enquiry.referrals = updatedReferrals;
      }

      state = {
        data: {
          ...data,
          enquiry: {
            ...enquiry,
            referrals: enquiry.referrals
          }
        }
      };

      return state;
    }

    case EnquiresActionTypes.CLEAR_ALL_ENQUIRY_STATE: {
      return initialState;
    }

    case EnquiresActionTypes.CLEAR_ENQUIRIES: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          enquiries: undefined
        }
      };
      return state;
    }

    case EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_START: {
      return {
        ...state,
        zipDownloadStatus: false,
        pdfDownloadStatus: false,
        downloadingCombinedPdf:
          action.payload.fileType === 'pdf'
            ? action.payload.enquiryId
            : state.downloadingCombinedPdf,
        downloadingCombinedZip:
          action.payload.fileType === 'zip'
            ? action.payload.enquiryId
            : state.downloadingCombinedZip
      };
    }

    case EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_SUCCESS: {
      return {
        ...state,
        zipDownloadStatus:
          action.payload.fileType === 'zip' ? true : state.zipDownloadStatus,
        pdfDownloadStatus:
          action.payload.fileType === 'pdf' ? true : state.pdfDownloadStatus,
        downloadingCombinedPdf:
          action.payload.fileType === 'pdf'
            ? undefined
            : state.downloadingCombinedPdf,
        downloadingCombinedZip:
          action.payload.fileType === 'zip'
            ? undefined
            : state.downloadingCombinedZip
      };
    }

    case EnquiresActionTypes.DOWNLOAD_ENQUIRY_COMBINED_FILE_FAILURE: {
      return {
        ...state,
        zipDownloadStatus: false,
        pdfDownloadStatus: false,
        downloadingCombinedPdf:
          action.payload.fileType === 'pdf'
            ? action.payload.error
            : state.downloadingCombinedPdf,
        downloadingCombinedZip:
          action.payload.fileType === 'zip'
            ? action.payload.error
            : state.downloadingCombinedZip
      };
    }

    case EnquiresActionTypes.RESET_DOWNLOAD_ENQUIRY_COMBINED_FILE: {
      return {
        ...state,
        zipDownloadStatus:
          action.payload.fileType === 'zip'
            ? undefined
            : state.zipDownloadStatus,
        pdfDownloadStatus:
          action.payload.fileType === 'pdf'
            ? undefined
            : state.pdfDownloadStatus,
        downloadingCombinedPdf:
          action.payload.fileType === 'pdf'
            ? undefined
            : state.downloadingCombinedPdf,
        downloadingCombinedZip:
          action.payload.fileType === 'zip'
            ? undefined
            : state.downloadingCombinedZip
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_START: {
      return {
        ...state,
        attachmentPreviewUrl: undefined,
        isLoadingAttachmentPreviewUrl: true
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_SUCCESS: {
      return {
        ...state,
        attachmentPreviewUrl: action.payload,
        isLoadingAttachmentPreviewUrl: false
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_PREVIEW_URL_FAILURE: {
      return {
        ...state,
        attachmentPreviewUrl: undefined,
        isLoadingAttachmentPreviewUrl: false
      };
    }

    case EnquiresActionTypes.RESET_ATTACHMENT_PREVIEW_URL: {
      return {
        ...state,
        attachmentPreviewUrl: undefined,
        isLoadingAttachmentPreviewUrl: undefined
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_START: {
      return {
        ...state,
        attachmentDownloadUrl: undefined,
        isLoadingAttachmentDownloadUrl: true
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_SUCCESS: {
      return {
        ...state,
        attachmentDownloadUrl: action.payload,
        isLoadingAttachmentDownloadUrl: false
      };
    }

    case EnquiresActionTypes.GET_ATTACHMENT_DOWNLOAD_URL_FAILURE: {
      return {
        ...state,
        attachmentDownloadUrl: undefined,
        isLoadingAttachmentDownloadUrl: false
      };
    }

    case EnquiresActionTypes.RESET_ATTACHMENT_DOWNLOAD_URL: {
      return {
        ...state,
        attachmentDownloadUrl: undefined,
        isLoadingAttachmentDownloadUrl: undefined
      };
    }

    case EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_START: {
      return {
        ...state,
        enquiryConfirmationPDFDownloadUrl: undefined,
        isLoadingEnquiryConfirmationPDFDownloadUrl: true
      };
    }

    case EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_SUCCESS: {
      return {
        ...state,
        enquiryConfirmationPDFDownloadUrl: action.payload?.url,
        isLoadingEnquiryConfirmationPDFDownloadUrl: false
      };
    }

    case EnquiresActionTypes.GET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL_FAILURE: {
      return {
        ...state,
        enquiryConfirmationPDFDownloadUrl: undefined,
        isLoadingEnquiryConfirmationPDFDownloadUrl: false
      };
    }

    case EnquiresActionTypes.RESET_ENQUIRY_CONFIRMATION_PDF_DOWNLOAD_URL: {
      return {
        ...state,
        enquiryConfirmationPDFDownloadUrl: undefined,
        isLoadingEnquiryConfirmationPDFDownloadUrl: undefined
      };
    }

    case EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_START: {
      return {
        ...state,
        downloadAdvancedOptions: [],
        isLoadingDownloadAdvancedOptions: true
      };
    }

    case EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_SUCCESS: {
      return {
        ...state,
        downloadAdvancedOptions: action.payload,
        isLoadingDownloadAdvancedOptions: false
      };
    }

    case EnquiresActionTypes.GET_DOWNLOAD_ADVANCED_OPTIONS_FAILURE: {
      return {
        ...state,
        downloadAdvancedOptions: [],
        isLoadingDownloadAdvancedOptions: false
      };
    }

    case EnquiresActionTypes.RESET_DOWNLOAD_ADVANCED_OPTIONS: {
      return {
        ...state,
        downloadAdvancedOptions: [],
        isLoadingDownloadAdvancedOptions: false
      };
    }

    default:
      return state;
  }
};

export { reducer as EnquiresReducer };
